import {useCallback} from 'react';
import {useNavigate} from 'react-router-dom';
import {
  type SelectOption,
  type IVIntent,
  IV_DOCUMENT_IMAGE_TYPES,
  GUEST_FORM_NAMES,
} from '@chekin/core';
import {useIVStore, useUpdateIvIntent} from '@chekin/shared';
import {PATHS} from 'routes/constants';
import {getIVIntentRemoteSession} from 'hooks/iv/useIVRemoteSync';
import {DocumentChoice} from '@chekin/core';

type FormTypes = {
  [GUEST_FORM_NAMES.nationality]: SelectOption;
  [GUEST_FORM_NAMES.document_type]: SelectOption<DocumentChoice> | null;
};

type Props = {
  onSuccess?: (data: IVIntent) => void;
};
export const useDocumentSelection = ({onSuccess}: Props = {}) => {
  const navigate = useNavigate();
  const {setDocumentType, setNationality} = useIVStore();
  const goToUploading = useCallback(() => {
    navigate(`../${PATHS.verification.uploadingType}/${IV_DOCUMENT_IMAGE_TYPES.front}`);
  }, [navigate]);

  const {sendUpdateIvIntentRequest, isLoading} = useUpdateIvIntent({
    onSuccess,
    postHandler: goToUploading,
  });

  const confirm = useCallback(
    (data: FormTypes) => {
      const docType = data?.[GUEST_FORM_NAMES.document_type]?.data;
      if (docType) {
        setDocumentType(docType);
      }
      const nationality = data[GUEST_FORM_NAMES.nationality]?.value;
      if (nationality) {
        setNationality(nationality);
      }

      const intentId = getIVIntentRemoteSession();
      if (intentId && docType && nationality) {
        sendUpdateIvIntentRequest({
          id: intentId,
          nationality,
          type_doc: docType,
        });
      } else {
        goToUploading();
      }
    },
    [goToUploading, sendUpdateIvIntentRequest, setDocumentType, setNationality],
  );

  return {
    isLoading,
    confirm,
  };
};
